import { HttpErrorResponse } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {environment} from '@environments/environment';

export function handleError(error: HttpErrorResponse): Observable<any> {
    if (!environment.production) {
      console.error('Ein Fehler ist aufgetreten', error.status + ': ' + error.message);
    }
  return throwError(() => error);
}
